import CommonHeadings from "helper/constant/headings";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { Button } from "primereact/button";
import { useLocation, useNavigate } from "react-router-dom";
import { query, collection, getDocs, updateDoc, doc } from "firebase/firestore";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import RoutingPaths from "helper/routingPath";
import Swal from "sweetalert2";
import StudentsDetailView from "components/studentView/detailInfo";
import StudentsAttedanceView from "components/studentView/attedance";
import ButtonLabels from "helper/constant/buttonLabels";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import TransactionData from "components/studentView/transactionData";



function StudentsView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [statusButtonlabel, setStatusButtonlabel] = useState(ButtonLabels.activeLabel);
  const [studentsID, setStudentsID] = useState();

  // MARK: use Effect function
  useEffect(() => {
    editButtonLabel();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Use Layout Method
  useLayoutEffect(() => {
    document.title = CommonHeadings.studentView;
  }, []);

  const tabsData = [
    { id: 1, label: "Student Info" },
    { id: 2, label: "Attendance View" },
    { id: 3, label: "Transaction History" },
  ];

  const [activeTab, setActiveTab] = useState(tabsData[0].id);

  // tabs are active
  const handleTabClick = async (id) => {
    setActiveTab(id);
  };

  // MARK: API
  async function fetchStudentsApi() {
    let q = query(
      collection(dbFirestore, TableName.students)
    );
    const querySnapshot = await getDocs(q);
    const array = querySnapshot.docs.map((docs) => ({ ...docs.data(), id: docs.id }));
    const studentObject = array.find((student) => student.id === location.state.id);
  
    if (!studentObject) {
      return null; 
    }
  
    return studentObject;
  }

  async function editButtonLabel() {
    try {
      const studentData = await fetchStudentsApi();
  
      if (!studentData) {
        toast.error("Student data not found.");
        <ToastContainer/>
        return;
      }
  
      setStudentsID(location.state.id);
  
      if (studentData["status"]) {
        setStatusButtonlabel(
          studentData["status"] === "active" ? ButtonLabels.leaveLabel : ButtonLabels.activeLabel
        );
      } else {
        toast.error("Status is undefined for student.");
        <ToastContainer/>
      }
    } catch (error) {
      toast.error("Error fetching student data:", error);
      <ToastContainer/>
    }
  }

  async function updateStudentsApi() {
    const studentStatus = await fetchStudentsApi();

   await updateDoc(doc(dbFirestore, TableName.students, studentsID), {
      status: studentStatus["status"] === "active" ? "leave" : "active",
    });

    navigate(RoutingPaths.studentsList)
  }

  const tapOnStatusButton = () => {
    Swal.fire({
      title: "Are you sure?",
      text: location.state.status === "active" ? `You want to marked it as "Leave"` : `You want to marked it as "Active"`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "var(--delete-button-color)",
      cancelButtonColor: "var(--cancel-button-list)",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        updateStudentsApi();
      }
    });

  };

  const Tabs = () => {
    return (
      <>
        <div style={{ marginBottom: "1rem", paddingLeft: "1rem" }}>
          <Button icon="pi pi-arrow-left"
            type="button"
            onClick={() => navigate(-1)}
            className="view__back_button me-3"
          />
        </div>
        <div className="search__main_div" style={{ paddingLeft: "2rem" }}>
          <div className="tabs" style={{ flexGrow: "1" }}>
            {tabsData.map((tab) => (
              <button
                key={tab.id}
                className={`tab-button tab-buttons ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => handleTabClick(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

        </div>
      </>
    );
  };

  const header = Tabs();

  return (
    <>
      <div className="modules__main__div">
        <div className="col-12">
          <div className="card modules__card">
            {header}

            {activeTab === 1 && <StudentsDetailView />}
            {activeTab === 2 && <StudentsAttedanceView />}
            {activeTab === 3 && <TransactionData />}

            {activeTab === 1 && <div className="mb-5">
              <Button label={statusButtonlabel} type="button" onClick={tapOnStatusButton} className="view__student_status_button" />
            </div>}
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentsView;

